import Base from '../base.js'
export default class Theme extends Base {
  constructor () {
    super('/themes')
  }
}
